import { useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useAnalyticsTracker } from "../Analytics";
import Avatar from "../Avatar";
import GuideProfileVideo from "../GuideProfileVideo";
import styles from "./VideoAvatar.module.scss";

interface Props {
  guideId: string;
  avatarSrc: string;
  videoPublicId: string;
}

export default function VideoAvatar({
  guideId,
  avatarSrc,
  videoPublicId,
}: Props) {
  const [state, setState] = useState({ isOpen: false });
  const tracker = useAnalyticsTracker();
  function handleClick() {
    setState({ isOpen: true });

    tracker.trackEvent({
      category: "onpage",
      action: "click-guide-profile-pic",
      label: `guide-profile-pic-${guideId}`,
    });
  }
  return (
    <div className={styles.VideoAvatarContainer}>
      <span onClick={handleClick}>
        <Avatar name="" size={88} src={avatarSrc} />
      </span>
      <span className={styles["AvatarStoryButtonSmall"]}>Watch video</span>
      {state.isOpen ? (
        <Modal
          blockScroll={false}
          open={state.isOpen}
          onClose={() => setState({ isOpen: false })}
        >
          <GuideProfileVideo guideId={guideId} publicId={videoPublicId} />
        </Modal>
      ) : null}
    </div>
  );
}
